import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Popup from "../../../../../components/WMS/Mobile/Popup";
import {FormattedMessage} from "react-intl";
import {ReactComponent as ScanIcon} from "assets/img/wms/scan.svg"
import {BarCodeScannerContext} from "../../../../../contexts/barCodeScannerContext";
import {
    getWMSContainers,
    getWMSContainerWithCodeBar,
    patchWMSContainerMemberWithCodebar
} from "../../../../../api/wms/wmsContainers/wmsContainers";
import {WMSContext} from "../../../context/WMSContext";
import {WmsContainerType} from "../../../../../utils/WMSContainerType";
import WrongScanToast from "../../../../../components/WMS/WrongScanToast";

ScanWorkstationModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleWorkstationClaimed: PropTypes.func.isRequired,
    handleAlreadyTakenWorkstation: PropTypes.func.isRequired,
};


function ScanWorkstationModal({open, handleClose, handleWorkstationClaimed, handleAlreadyTakenWorkstation}) {
    const {scannedString, setEnableScan} = useContext(BarCodeScannerContext)
    const {currentMember} = useContext(WMSContext)
    const [notPackingStation, setNotPackingStation] = useState(false)
    const [openWrongScanToast, setOpenWrongScanToast] = useState(false)

    useEffect(() => {
        if (scannedString && scannedString !== "") {
            setEnableScan(false)
            getWMSContainerWithCodeBar(scannedString, false).then((container) => {
                if (WmsContainerType.PACKING_STATION !== container.type) {
                    setNotPackingStation(true)
                    setEnableScan(true)
                    return
                } else {
                    setNotPackingStation(false)
                }

                if (container.member) {
                    if (container.member.id === currentMember.id) {
                            handleWorkstationClaimed(container, container.computerId)
                    } else {
                        handleAlreadyTakenWorkstation(container)
                    }
                } else {
                    patchWMSContainerMemberWithCodebar(container.codebar, currentMember).then(() => {
                        handleWorkstationClaimed(container, container.computerId)
                    })
                }
            }).catch(() => {
                setNotPackingStation(true)
                setEnableScan(true)
                setOpenWrongScanToast(true)
            })
        }
    }, [scannedString]);
    return (
        <>
            {openWrongScanToast && (
                <WrongScanToast
                    open={openWrongScanToast}
                    handlClose={() => setOpenWrongScanToast(false)}
                />
            )}
            <Popup
                open={open}
                onClose={handleClose}
                title={notPackingStation ? <FormattedMessage id={"wms.packing.modal.scanWorkstation.wrong.title"} /> : <FormattedMessage id={"wms.packing.modal.scanWorkstation.title"}/>}
                subtitle={notPackingStation ? <FormattedMessage id={"wms.packing.modal.scanWorkstation.wrong.subtitle"} /> : <FormattedMessage id={"wms.packing.modal.scanWorkstation.subtitle"}/>}
                icon={<ScanIcon/>}
                isMobile
                strictOnclose
            />
        </>
    );
}

export default ScanWorkstationModal;